<script lang="ts" setup>
import { Button,Menu } from 'primevue'
import { computed, onMounted, onUnmounted,ref } from 'vue'

import flagEn from '@/assets/flags/en.svg?url'
import flagEs from '@/assets/flags/es.svg?url'
import flagFr from '@/assets/flags/fr.svg?url'
import flagDe from '@/assets/flags/de.svg?url'
import flagNl from '@/assets/flags/nl.svg?url'
import flagIt from '@/assets/flags/it.svg?url'
import { i18next,setI18nLanguage } from '@/i18n'

const menu = ref()
const currentLang = ref(i18next.resolvedLanguage || i18next.language || 'it')

const currentLanguage = computed(() => {
  return languages.find(l => l.code === currentLang.value) || languages[0]
})

const onLanguageChanged = (lng: string) => {
  currentLang.value = lng
}

onMounted(() => {
  i18next.on('languageChanged', onLanguageChanged)
})

onUnmounted(() => {
  i18next.off('languageChanged', onLanguageChanged)
})

const languages = [
  { code: 'it', name: 'Italiano', flag: flagIt, label: 'IT' },
  { code: 'en', name: 'English', flag: flagEn, label: 'EN' },
  { code: 'es', name: 'Español', flag: flagEs, label: 'ES' },
  { code: 'fr', name: 'Français', flag: flagFr, label: 'FR' },
  { code: 'de', name: 'Deutsch', flag: flagDe, label: 'DE' },
  { code: 'nl', name: 'Nederlands', flag: flagNl, label: 'NL' },
]

const items = computed(() =>
  languages.map(lang => ({
    label: lang.name,
    code: lang.code,
    flag: lang.flag,
    command: () => changeLanguage(lang.code)
  }))
)

async function changeLanguage(language: string) {
  await setI18nLanguage(language)
}

const toggle = (event: Event) => {
  menu.value.toggle(event)
}
</script>

<template>
  <div class="language-selector">
    <Button
      type="button"
      class="flex items-center gap-2 px-3 py-2"
      text
      @click="toggle"
    >
      <img
        :alt="currentLanguage.name"
        :src="currentLanguage.flag"
        class="w-5 h-5"
      />
      <span class="font-medium">{{ currentLanguage.label }}</span>
      <i class="pi pi-chevron-down text-xs"></i>
    </Button>
    <Menu ref="menu" :model="items" :popup="true">
      <template #item="{ item }">
        <div class="flex items-center gap-3 px-3 py-2 cursor-pointer">
          <img
            :src="item.flag"
            :alt="typeof item.label === 'string' ? item.label : ''"
            class="w-5 h-5"
          />
          <span>{{ typeof item.label === 'function' ? item.label() : (item.label || '') }}</span>
        </div>
      </template>
    </Menu>
  </div>
</template>

<style scoped>
.language-selector img {
  min-width: 20px;
  min-height: 20px;
  object-fit: cover;
  border-radius: 2px;
}

.language-selector :deep(.p-menu-item-icon) {
  width: 20px !important;
  height: 20px !important;
  object-fit: cover;
  border-radius: 2px;
}

.language-selector :deep(.p-menu-item img) {
  width: 20px;
  height: 20px;
  object-fit: cover;
  border-radius: 2px;
}
</style>

